import { render, staticRenderFns } from "./NextSectionBtn.vue?vue&type=template&id=e6896dd4&scoped=true&"
import script from "./NextSectionBtn.vue?vue&type=script&lang=js&"
export * from "./NextSectionBtn.vue?vue&type=script&lang=js&"
import style0 from "./NextSectionBtn.vue?vue&type=style&index=0&id=e6896dd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6896dd4",
  null
  
)

export default component.exports